(function () {
	'use strict';

	var CONFIG = {
		storeUrls: {
			international: 'https://woomii.com/',
			japan: 'https://woomii.jp/'
		},
		storeHostnames: {
			international: ['woomii.com'],
			japan: ['woomii.jp']
		},
		labels: {
			international: 'INTERNATIONAL',
			japan: 'JAPAN | JPY',
			en: 'EN',
			ja: 'JP'
		}
	};

	var ROOT_SELECTOR = '[data-navy-store-locale-switcher]';

	function normalizeHostname(hostname) {
		return String(hostname || '').toLowerCase().replace(/^www\./, '');
	}

	function hostnameMatches(store, hostname) {
		return (CONFIG.storeHostnames[store] || []).some(function (configuredHostname) {
			return normalizeHostname(configuredHostname) === hostname;
		});
	}

	function getCurrentStore() {
		var hostname = normalizeHostname(window.location.hostname);

		if (hostnameMatches('japan', hostname)) return 'japan';
		if (hostnameMatches('international', hostname)) return 'international';

		// Theme-preview and unlisted aliases use the international presentation.
		return 'international';
	}

	function normalizeLocale(locale) {
		var normalized = String(locale || '').toLowerCase();
		return normalized === 'jp' ? 'ja' : normalized.split('-')[0];
	}

	function getCurrentLocale(root) {
		var liquidLocale = normalizeLocale(root.getAttribute('data-current-locale'));
		if (liquidLocale === 'en' || liquidLocale === 'ja') return liquidLocale;

		var documentLocale = normalizeLocale(document.documentElement.lang);
		return documentLocale === 'ja' ? 'ja' : 'en';
	}

	function getPanel(root) {
		return root.classList.contains('navy-language-options')
			? root
			: root.querySelector('.navy-language-options');
	}

	function getContainer(root) {
		return root.closest('.navy-language-dropdown-wrapper') ||
			root.closest('.navy-language-desktop-dropdown-wrapper') ||
			root;
	}

	function getToggle(root) {
		var sideMenuToggle = root.querySelector('.navy-language-toggle');
		if (sideMenuToggle) return sideMenuToggle;

		var desktopWrapper = root.closest('.navy-language-desktop-dropdown-wrapper');
		return desktopWrapper
			? desktopWrapper.querySelector('.navy-language-desktop-dropdown')
			: null;
	}

	function collectLocaleUrls(panel) {
		var urls = {};

		panel.querySelectorAll('.navy-language-option[data-locale][data-url]').forEach(function (option) {
			var locale = normalizeLocale(option.getAttribute('data-locale'));
			if (locale === 'en' || locale === 'ja') {
				urls[locale] = option.getAttribute('data-url');
			}
		});

		return urls;
	}

	function createOption(optionConfig) {
		var option = document.createElement('div');

		option.className = 'navy-language-option';
		option.textContent = optionConfig.label;
		option.setAttribute('data-url', optionConfig.url);
		option.setAttribute('data-option-type', optionConfig.type);
		option.setAttribute('data-option-value', optionConfig.value);

		if (optionConfig.locale) {
			option.setAttribute('data-locale', optionConfig.locale);
		}

		if (optionConfig.current) {
			option.classList.add('current');
			option.setAttribute('aria-current', 'true');
		} else {
			option.setAttribute('role', 'link');
			option.setAttribute('tabindex', '0');
		}

		return option;
	}

	function getOptions(root, localeUrls) {
		if (getCurrentStore() === 'japan') {
			var currentLocale = getCurrentLocale(root);
			var localeOptions = [];

			if (localeUrls.en) {
				localeOptions.push({
					label: CONFIG.labels.en,
					url: localeUrls.en,
					type: 'locale',
					value: 'en',
					locale: 'en',
					current: currentLocale === 'en'
				});
			}

			if (localeUrls.ja) {
				localeOptions.push({
					label: CONFIG.labels.ja,
					url: localeUrls.ja,
					type: 'locale',
					value: 'ja',
					locale: 'ja',
					current: currentLocale === 'ja'
				});
			}

			return localeOptions;
		}

		return [
			{
				label: CONFIG.labels.international,
				url: CONFIG.storeUrls.international,
				type: 'store',
				value: 'international',
				current: true
			},
			{
				label: CONFIG.labels.japan,
				url: CONFIG.storeUrls.japan,
				type: 'store',
				value: 'japan',
				current: false
			}
		];
	}

	function setOpen(root, open) {
		var panel = getPanel(root);
		var toggle = getToggle(root);
		var sideMenuContainer = root.closest('.navy-language-dropdown-wrapper');

		if (!panel) return;

		panel.classList.toggle('show', open);
		if (sideMenuContainer) sideMenuContainer.classList.toggle('is-open', open);
		if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
	}

	function closeOtherSwitchers(activeRoot) {
		document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
			if (root !== activeRoot) setOpen(root, false);
		});
	}

	function navigate(option) {
		if (option.classList.contains('current')) return;

		var url = option.getAttribute('data-url');
		if (!url) return;

		// Prevent the legacy automatic redirect from overriding an explicit
		// EN/JP choice during the destination page load.
		if (option.getAttribute('data-option-type') === 'locale') {
			try {
				window.sessionStorage.setItem('navy_manual_switch', '1');
			} catch (error) {}
		}

		window.location.assign(url);
	}

	function render(root) {
		var panel = getPanel(root);
		if (!panel) return;

		var localeUrls = collectLocaleUrls(panel);
		var options = getOptions(root, localeUrls);
		var fragment = document.createDocumentFragment();

		options.forEach(function (optionConfig) {
			fragment.appendChild(createOption(optionConfig));
		});

		panel.replaceChildren(fragment);
		root.setAttribute('data-switcher-mode', getCurrentStore());

		var label = root.querySelector('.navy-locale-label');
		var currentOption = options.find(function (option) {
			return option.current;
		});

		if (label && currentOption) {
			label.textContent = currentOption.label;
		}
	}

	function initSwitcher(root) {
		if (root.getAttribute('data-navy-switcher-initialized') === 'true') return;

		render(root);

		var panel = getPanel(root);
		var toggle = getToggle(root);

		if (!panel || !toggle) return;

		root.setAttribute('data-navy-switcher-initialized', 'true');
		toggle.setAttribute('role', 'button');
		toggle.setAttribute('aria-haspopup', 'true');
		toggle.setAttribute('aria-expanded', 'false');

		if (!toggle.hasAttribute('tabindex') && toggle.tagName !== 'BUTTON') {
			toggle.setAttribute('tabindex', '0');
		}

		function toggleSwitcher(event) {
			if (event.target.closest('.navy-language-options')) return;

			event.preventDefault();
			event.stopPropagation();

			var shouldOpen = !panel.classList.contains('show');
			closeOtherSwitchers(root);
			setOpen(root, shouldOpen);
		}

		toggle.addEventListener('click', toggleSwitcher);
		toggle.addEventListener('keydown', function (event) {
			if (event.key === 'Enter' || event.key === ' ') {
				toggleSwitcher(event);
			}
		});

		panel.addEventListener('click', function (event) {
			var option = event.target.closest('.navy-language-option');
			if (!option || !panel.contains(option)) return;

			event.stopPropagation();
			navigate(option);
		});

		panel.addEventListener('keydown', function (event) {
			if (event.key !== 'Enter' && event.key !== ' ') return;

			var option = event.target.closest('.navy-language-option');
			if (!option || !panel.contains(option)) return;

			event.preventDefault();
			navigate(option);
		});
	}

	function init(scope) {
		var context = scope || document;

		if (context.matches && context.matches(ROOT_SELECTOR)) {
			initSwitcher(context);
		}

		context.querySelectorAll(ROOT_SELECTOR).forEach(initSwitcher);
	}

	document.addEventListener('click', function (event) {
		document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
			if (!getContainer(root).contains(event.target)) {
				setOpen(root, false);
			}
		});
	});

	document.addEventListener('keydown', function (event) {
		if (event.key !== 'Escape') return;

		document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
			setOpen(root, false);
		});
	});

	document.addEventListener('shopify:section:load', function (event) {
		init(event.target);
	});

	window.NavyStoreLocaleSwitcher = {
		config: CONFIG,
		getCurrentStore: getCurrentStore,
		init: init
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			init(document);
		});
	} else {
		init(document);
	}
})();
